import { useReducer } from 'react'

// Holds the donor's tribute selection across the donation flow. Stores
// the committed state only — Tribute owns the live editing copy
// and calls setState here when the donor saves. Adapted from
// donate_v6's useTribute (which is inline-form-only and lives on this
// hook for state + validation + per-field input props).
//
// State + draft shape match v6 so the same Tribute model +
// nested-attributes acceptance on Order works.

const reducer = (state, action) => {
  switch (action.type) {
  case 'setState':
    return action.value
  default:
    throw new Error('Invalid reducer action')
  }
}

const useTribute = ({ tribute, order }) => {
  const [ state, dispatch ] = useReducer(reducer, {
    enabled: !!order.honoree_name,
    honoree_name: order.honoree_name || '',
    tribute_type: tribute.tribute_types?.[0],
    has_recipient: false,
    given_by: '',
    recipient_name: '',
    recipient_email: '',
    recipient_message: '',
  })

  const setState = value => dispatch({ type: 'setState', value })

  // saveDraft spreads this into the order: enabled → tribute_attributes
  // gets the form contents, disabled → _destroy clears any pre-existing
  // tribute on the order. The `enabled` field itself never reaches the
  // backend; it's a UI-only toggle that controls whether we send
  // attributes or _destroy.
  const draftOrderProps = () => {
    const { enabled, ...tribute_attributes } = state
    return enabled
      ? { tribute_attributes }
      : { tribute_attributes: { _destroy: true } }
  }

  return { ...tribute, state, setState, draftOrderProps }
}

export default useTribute
